'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _jsxFileName = 'src/new-business/quick-quote/cover.js';
var _level = require('@marmalade/bling/lib/level');
var _level2 = _interopRequireDefault(_level);
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _actions = require('@marmalade/ldi/lib/quote/actions');
var _selectors = require('@marmalade/ldi/lib/quote/selectors');
var _propTypes = require('@marmalade/prop-types');
var _actions2 = require('@marmalade/query/lib/actions');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _reduxWindow = require('redux-window');
var _form = require('./form');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Label = function Label(_ref) {
  var label = _ref.label,
    price = _ref.price,
    secondaryPrice = _ref.secondaryPrice,
    onClick = _ref.onClick,
    theme = _ref.theme,
    width = _ref.width,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === undefined ? '45%' : _ref$maxWidth,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === undefined ? 'Apply now' : _ref$buttonText,
    _ref$buttonProminence = _ref.buttonProminence,
    buttonProminence = _ref$buttonProminence === undefined ? 'primary' : _ref$buttonProminence;
  var mobile = width < theme.breakpoint_xs;
  return _react2.default.createElement(_glamorous2.default.Div, {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    textAlign: 'center',
    marginBottom: mobile ? theme.space_md : 10,
    minWidth: mobile ? '225px' : 'auto',
    maxWidth: maxWidth,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: undefined
  }, _react2.default.createElement(_glamorous2.default.H3, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: undefined
  }, label), _react2.default.createElement(_glamorous2.default.H4, {
    marginBottom: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40
    },
    __self: undefined
  }, price), _react2.default.createElement(_glamorous2.default.P, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: undefined
  }, secondaryPrice), _react2.default.createElement(_button2.default, {
    onClick: onClick,
    prominence: buttonProminence,
    text: buttonText,
    block: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: undefined
  }));
};
Label.propTypes = {
  label: _propTypes2.string.isRequired,
  price: (0, _propTypes2.oneOfType)([_propTypes2.string, _propTypes2.object]),
  secondaryPrice: _propTypes2.string.isRequired,
  onClick: _propTypes2.func.isRequired,
  theme: _propTypes2.object.isRequired,
  width: _propTypes2.number.isRequired,
  maxWidth: _propTypes2.string,
  buttonText: _propTypes2.string,
  buttonProminence: _propTypes2.string
};
var CoverLabel = (0, _glamorous.withTheme)(Label);
var Cover = function (_Component) {
  _inherits(Cover, _Component);
  function Cover() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, Cover);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Cover.__proto__ || Object.getPrototypeOf(Cover)).call.apply(_ref2, [this].concat(args))), _this), _this.apply = function (days) {
      return function () {
        var _this$props = _this.props,
          setQueries = _this$props.setQueries,
          history = _this$props.history,
          postcode = _this$props.postcode;
        setQueries({
          postcode: postcode,
          cover: days,
          policyQuote: _this.props['quote' + days]
        });
        history.push('/ldi/new/stage1');
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Cover, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var learnerQuotes = [30, 60, 90, 120, 180, 240];
      var fdiQuote = this.props.fdiQuotes.find(function (quote) {
        return quote.milage === '10000';
      });
      var fdiDecline = fdiQuote && fdiQuote.premium && fdiQuote.premium.rule ? fdiQuote.premium.rule === 'DECLINE' : true;
      return _react2.default.createElement(_level2.default, {
        breakpoint: 'xs',
        style: {
          flexFlow: 'column nowrap'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: this
      }, !this.props.fetching && _react2.default.createElement(_react2.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103
        },
        __self: this
      }, _react2.default.createElement('div', {
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104
        },
        __self: this
      }, learnerQuotes.map(function (days) {
        return _react2.default.createElement(CoverLabel, {
          label: days + ' Days',
          price: '\xA3' + _this2.props['quote' + days],
          secondaryPrice: '(\xA3' + _this2.props['quote' + days + 'daily'] + ' a day)',
          key: days,
          onClick: _this2.apply(days),
          width: _this2.props.width,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106
          },
          __self: _this2
        });
      })), this.props.fdiQuickQuote && fdiQuote && fdiQuote.premium && _react2.default.createElement('div', {
        style: {
          display: 'flex',
          justifyContent: 'space-evenly',
          flexWrap: 'wrap',
          marginTop: '1em'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117
        },
        __self: this
      }, _react2.default.createElement(CoverLabel, {
        label: 'Annual Cover',
        price: fdiDecline ? '' : _react2.default.createElement(_react2.default.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 131
          },
          __self: this
        }, '\xA3' + parseFloat(fdiQuote.monthlyPremium).toFixed(2) + ' ', _react2.default.createElement('sup', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 133
          },
          __self: this
        }, 'p/m')),
        secondaryPrice: fdiDecline ? '' : '(\xA3' + parseFloat(fdiQuote.creditDepositAmount).toFixed(2) + ' deposit)',
        buttonText: 'Details',
        buttonProminence: 'tertiary',
        onClick: function onClick() {
          return document.getElementById('fdiPanel').scrollIntoView({
            behavior: 'smooth'
          });
        },
        width: this.props.width,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        },
        __self: this
      }))));
    }
  }]);
  return Cover;
}(_react.Component);
Cover.propTypes = {
  history: _propTypes.history.isRequired,
  // STP
  postcode: _propTypes2.string.isRequired,
  quote30: _propTypes2.string.isRequired,
  quote60: _propTypes2.string.isRequired,
  quote90: _propTypes2.string.isRequired,
  quote120: _propTypes2.string.isRequired,
  quote180: _propTypes2.string.isRequired,
  quote240: _propTypes2.string.isRequired,
  quote30daily: _propTypes2.string.isRequired,
  quote60daily: _propTypes2.string.isRequired,
  quote90daily: _propTypes2.string.isRequired,
  quote180daily: _propTypes2.string.isRequired,
  fdiQuotes: _propTypes2.array.isRequired,
  width: _propTypes2.number.isRequired,
  fdiQuickQuote: _propTypes2.bool,
  // DTP
  clearQuotes: _propTypes2.func.isRequired,
  setQueries: _propTypes2.func.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  var quotes = (0, _selectors.getQuotes)(state);
  var quote30 = quotes.find(function (quote) {
    return String(quote.cover) === '30';
  });
  var quote60 = quotes.find(function (quote) {
    return String(quote.cover) === '60';
  });
  var quote90 = quotes.find(function (quote) {
    return String(quote.cover) === '90';
  });
  var quote120 = quotes.find(function (quote) {
    return String(quote.cover) === '120';
  });
  var quote180 = quotes.find(function (quote) {
    return String(quote.cover) === '180';
  });
  var quote240 = quotes.find(function (quote) {
    return String(quote.cover) === '240';
  });
  return {
    postcode: (0, _fieldInfo.getValue)(state, _form.formId, 'postcode'),
    quote30: quote30 ? quote30.premium : null,
    quote60: quote60 ? quote60.premium : null,
    quote90: quote90 ? quote90.premium : null,
    quote120: quote180 ? quote180.premium : null,
    quote180: quote180 ? quote180.premium : null,
    quote240: quote180 ? quote180.premium : null,
    quote30daily: quote30 ? quote30.daily : null,
    quote60daily: quote60 ? quote60.daily : null,
    quote90daily: quote90 ? quote90.daily : null,
    quote120daily: quote120 ? quote180.daily : null,
    quote180daily: quote180 ? quote180.daily : null,
    quote240daily: quote240 ? quote180.daily : null,
    width: (0, _reduxWindow.getWidth)(state),
    fetching: (0, _selectors.quoting)(state),
    fdiQuotes: (0, _selectors.getFDIQuotes)(state)
  };
}, {
  clearQuotes: _actions.clearQuotes,
  setQueries: _actions2.setQueries
})(Cover));